import React, { useRef, useState } from 'react';
import { UploadApi } from '../../../api/adminApi';
import './InlineImageUploader.css';

const InlineImageUploader = ({ value, onChange, label = 'Upload image', helperText }) => {
  const fileInputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const handlePick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setUploading(true);
    setError('');
    try {
      const { url } = await UploadApi.uploadImage(file);
      onChange(url);
    } catch (err) {
      setError(err.response?.data?.message || err.message || 'Upload failed');
    } finally {
      setUploading(false);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  return (
    <div className="inline-image-uploader">
      <div className="inline-upload-actions">
        <button
          type="button"
          className="admin-secondary-btn inline-upload-btn"
          onClick={handlePick}
          disabled={uploading}
        >
          {uploading ? 'Uploading…' : label}
        </button>
        {value && !uploading && (
          <button
            type="button"
            className="clear-btn inline-clear-btn"
            onClick={() => onChange('')}
          >
            Remove
          </button>
        )}
      </div>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        hidden
      />
      {value && (
        <div className="inline-image-preview">
          <img
            src={value}
            alt="Uploaded preview"
            onError={(event) => {
              // eslint-disable-next-line no-param-reassign
              event.currentTarget.style.display = 'none';
            }}
          />
        </div>
      )}
      {helperText && <p className="helper-text inline-helper-text">{helperText}</p>}
      {error && <p className="error-text inline-error-text">{error}</p>}
    </div>
  );
};

export default InlineImageUploader;
